/**
 * Low-graphics / Samsung Tizen detection.
 * Set on <html data-platform="tizen"> by main.jsx (UA sniff or ?lowgfx=1).
 */
export function isLowGfx() {
  return typeof document !== 'undefined'
    && document.documentElement.getAttribute('data-platform') === 'tizen';
}

export default isLowGfx;
